export default {
    select_currency_problem: "ជ្រើសរើសប្រភេទប្រាក់មិនជោគជ័យ",
    confirm_password:"Confirm Password មិនត្រឹមត្រូវ"
};
